module.exports = __webpack_public_path__ + "img/close_listing.65ea73ef.svg";